// src/modules/app-views/_apps/applekkus/landingPages/pages/Document/actions/dropdownMenu.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownNew,
  dropdownRemove,
  dropdownRestore,
  dropdownRemovePermanently,
} from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// DROPDOWN MENU CONFIGURATION
// *******************************************************************************
const landingPagesDocumentDropdownMenu = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',

    dropdownItems: [
      dropdownNew,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default landingPagesDocumentDropdownMenu;
